import { useState } from 'react';
import './SurveyModal.css'
import { useTranslation } from 'react-i18next';

function TextView ({title, type,question, saveAnswer,lng}){
    const { t } = useTranslation();

    const [otherText, setOtherText] = useState('');

    const handleTextChange = (newValue, question) => {
        const updatedText = newValue;
        setOtherText(updatedText);
        const answerType = question.AnswerType;
    
        if (answerType === 2) {
          saveAnswer(question.QuestionID, 2, updatedText);
        }
        //  else if (answerType === 3) {
        //   saveAnswer(question.QuestionID, 3, { selectedOption: selectedReasonsSingle[0], text: updatedText });
        // }
      };
    return (
        <div className="">
        <div className="survey_margin_top_and_bottom_page2 survey_common_style_center">
          <div className="survey_margin_bottom" style={{ textAlign: "center" }}>
            {title}
            {type !== 'from_select_text' && <span style={{ color: "#D3D3D3" }}>({t("optional")})</span>}
          </div>
  
          <textarea className="survey_text_area" style={lng === "arab" ? { direction: "rtl" } : null} placeholder={title} value={otherText}
            onChange={(e)=>handleTextChange(e.target.value,question)}></textarea>
        </div>
  
      </div>
    )
}

export default TextView;